import styled from '@emotion/styled';
import FONT from '@zola/zola-ui/src/styles/emotion/fonts';
import SPACING from '@zola/zola-ui/src/styles/emotion/spacing';

type QuickLinksWrapperProps = {
  hideContentOnScroll: boolean;
};

export const QuickLinksWrapper = styled.div`
  display: ${(props: QuickLinksWrapperProps) => (props.hideContentOnScroll ? 'none' : 'flex')};
  column-gap: ${SPACING.S24};
  align-items: center;
  height: 100%;

  a,
  label {
    font-size: ${FONT.FONT_SIZE_SMALLER} !important;
    font-weight: ${FONT.WEIGHT.SEMI_BOLD};
    margin-bottom: 0;
    &.nav-link--SecondaryNavSubLink {
      font-weight: ${FONT.WEIGHT.REGULAR};
    }
    // Don't show navSecondary hover style for quick links
    &.nav-dropdown__label--isSecondary:not(.nav-dropdown__label--active):hover::before,
    &.nav-link--SecondaryNavLink:not(.nav-link--active):hover::before {
      content: none !important;
    }
  }

  // fix for NavMapper z-index
  z-index: -1;
  > div {
    z-index: -2;
  }
`;
